var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "batsku--select__dialog",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.show,
        width: "700px",
        title: _vm.$t("stores::products-info::edit_sku_title"),
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "el-row",
        { staticClass: "batsku--select__wrap" },
        [
          _c("el-col", { attrs: { span: 4 } }, [
            _c("div", { staticClass: "batsku--select__setting" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("menu::stores::product-manager")) + " "
              ),
            ]),
          ]),
          _c(
            "el-col",
            { attrs: { span: 20 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "batsku--select__inner",
                  staticStyle: { width: "100%" },
                  attrs: { filterable: "" },
                  model: {
                    value: _vm.selectedSpu,
                    callback: function ($$v) {
                      _vm.selectedSpu = $$v
                    },
                    expression: "selectedSpu",
                  },
                },
                _vm._l(_vm.selection, function (item, index) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { value: index, label: item.title },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "batsku--select__leftRow",
          attrs: { disabled: _vm.selectedSpu === 0 },
          on: { click: _vm.pre },
        },
        [_c("i", { staticClass: "iconfont icondown-circle-01" })]
      ),
      _c(
        "el-form",
        {
          ref: "tableForm",
          staticClass: "batsku--select__form",
          attrs: { model: _vm.selectList[_vm.selectedSpu] },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.selectList[_vm.selectedSpu].skus,
                height: 350,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "SKU", prop: "skuId", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(row.skuId) +
                              _vm._s(
                                row.optionValueNames
                                  ? "-" + row.optionValueNames
                                  : ""
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("stores::products-info::use_stock"),
                  prop: "availableInventory",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("stores::products-info::goods_stock"),
                  prop: "skuInventory",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "safeInventory" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "stores::products-info::safe_stock"
                            ),
                          },
                          on: {
                            change: function (val) {
                              return _vm.handlePriceChange(scope, val)
                            },
                          },
                          model: {
                            value: _vm.priceDialogHeader.safeInventory,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.priceDialogHeader,
                                "safeInventory",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "priceDialogHeader.safeInventory",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-form-item",
                          {
                            key: $index,
                            attrs: {
                              prop: "skus." + $index + ".safeInventory",
                              rules: [
                                {
                                  trigger: "change",
                                  validator: _vm.checkInputSafe,
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "system::common::input_holder"
                                ),
                              },
                              model: {
                                value: row.safeInventory,
                                callback: function ($$v) {
                                  _vm.$set(row, "safeInventory", $$v)
                                },
                                expression: "row.safeInventory",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "batsku--select__rightRow",
          attrs: { disabled: _vm.selectedSpu === _vm.selectList.length - 1 },
          on: { click: _vm.next },
        },
        [_c("i", { staticClass: "iconfont icondown-circle-01" })]
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "72px" },
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "72px" },
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.confirm },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }